import React, { useState, useEffect, useRef } from "react";
import google from "../image/google.png";
import hirebeen from "../image/hirebeenLogo.png";
import H from "../image/H.png";
import hide from "../image/icons/hide.png";
import view from "../image/icons/view.png";
import Group1 from "../image/Group1.svg";
import Group2 from "../image/Group2.svg";
import Group3 from "../image/Group3.svg";
import { Link, Navigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { signup } from "../reducer/Actions";
import "./Signup.css";
import CustomButton from "../Reusable/CustomButton";
import axios from "axios";
import { API_URL, CALLBACK_URL, GOOGLE_CLIENT_ID } from "../apiConfig";
import TYPE from "../reducer/Type";
import { toast } from "react-toastify";

const Signup = ({ signup }) => {
  const [status, setStatus] = useState(false);
  const [show_tac, setShow_tac] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    first_name: "",
    last_name: "",
    password1: "",
    password2: "",
  });

  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const termsAndConditionsRef = useRef(null);

  const [visible, setVisible] = useState();
  const [visible1, setVisible1] = useState();
  const [signUp, setSignUp] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    teamsAndCondition: false,
  });

  const [errMsg, setErrMsg] = useState({
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    isEmailValid: true,
    isPasswordValid: true,
  });

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsButtonDisabled(false);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, {
      root: termsAndConditionsRef.current,
      threshold: 1,
    });

    if (termsAndConditionsRef.current) {
      observer.observe(termsAndConditionsRef.current.lastElementChild);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  // const { email, first_name, last_name, password1, password2 } = formData;
  // const handlingInput = (e) =>
  //   setFormData({ ...formData, [e.target.name]: e.target.value });
  // const handlingSubmit = (e) => {
  //   e.preventDefault();
  //   signup(email, first_name, last_name, password1, password2);
  //   setStatus(true);
  // };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setSignUp((prev) => ({ ...prev, password: password }));

    // Validate password
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (passwordRegex.test(password)) {
      setErrMsg((prev) => ({ ...prev, password: "", isPasswordValid: true }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        password:
          "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, a digit, and a special character.",
        isPasswordValid: false,
      }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const confirmPassword = e.target.value;
    setSignUp((prev) => ({ ...prev, confirmPassword }));

    // Check if passwords match
    if (confirmPassword === signUp.password) {
      setErrMsg((prev) => ({
        ...prev,
        confirmPassword: "",
        isConfirmPasswordValid: true,
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        confirmPassword: "Passwords do not match.",
        isConfirmPasswordValid: false,
      }));
    }
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setSignUp((prev) => ({ ...prev, email: email }));

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setErrMsg((prev) => ({ ...prev, email: "", isEmailValid: true }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        email: "Please enter a valid email.",
        isEmailValid: false,
      }));
    }
  };

  const handleSignUp = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // Need to check use of body to stringify
      const body = JSON.stringify({
        first_name: signUp.username,
        email: signUp.email,
        password1: signUp.password,
        password2: signUp.confirmPassword,
      });
      setLoading(true);

      const res = await axios.post(
        `${API_URL}/dj-rest-auth/registration/`,
        body,
        config
      );
      dispatch({
        type: TYPE.SIGNUP_SUCCESS,
      });

      setLoading(false);
      // console.log(res)
      if (res?.statusText === "Created") {
        toast.success("A verification email has been sent. Please verify your email address.", {
          autoClose: 1500,
        });
      } else {
        toast.error("Something went wrong. Pleast try again later.", {
          autoClose: 1500,
        });
      }
      setSignUp({
        email: "",
        password: "",
        username: "",
        confirmPassword: "",
      });

      return;
    } catch (err) {
      const errorMessage = err?.response?.data?.non_field_errors?.[0] ||
      err?.response?.data?.email?.[0] ||
      "An unexpected error occurred.";

      dispatch({
        type: TYPE.SIGNUP_FAIL,
      });
      toast.error(errorMessage, {
        autoClose: 2500,
      });
      setLoading(false);
      return;
    }
  };

  const reachGoogle = () => {
    const clientID = GOOGLE_CLIENT_ID;
    const callBackURI = CALLBACK_URL;
    window.location.replace(
      `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${callBackURI}&prompt=consent&response_type=code&client_id=${clientID}&scope=openid%20email%20profile&access_type=offline`
    );
  };

  const disableSignUp = () => {
    return (
      !signUp.username ||
      !signUp.email ||
      !signUp.password ||
      !errMsg.isEmailValid ||
      !errMsg.isPasswordValid ||
      errMsg.confirmPassword ||
      errMsg.username ||
      signUp.password !== signUp.confirmPassword ||
      !signUp.teamsAndCondition
    );
  };

  if (status) {
    return <Navigate to={"../"}></Navigate>;
  }
  return (
    <div className="grid grid-cols-2 gap-0 max-md:grid-cols-1">
      <div className="block w-full h-full bg-conic-gradient max-md:hidden">
        <div className="flex gap-2.5 self-start max-md:pr-5 mt-6 ml-6">
          <img
            loading="lazy"
            src={H}
            alt="H"
            className="shrink-1 aspect-[0.75] w-[29px]"
          />
          <img
            loading="lazy"
            src={hirebeen}
            alt="Hirebeen"
            className="shrink-0 my-auto max-w-full aspect-[5.56] w-[146px]"
          />
        </div>
        <div className="mx-9 mt-20 text-5xl font-bold text-white leading-[70px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full max-md:text-4xl max-md:leading-[68px]">
          Build your successful resume instantly using AI
        </div>
        <div className="z-10 self-center mt-3.5 max-w-full w-[574px]">
          <div className="flex gap-1 max-md:flex-col max-md:gap-0">
            <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col mt-16 grow max-md:mt-10">
                <img
                  loading="lazy"
                  alt="lazy"
                  src={Group2}
                  className="w-full"
                />
                <img
                  loading="lazy"
                  alt="lazy"
                  src={Group3}
                  className="w-full mt-5"
                />
              </div>
            </div>
            <div className="flex flex-col w-11/12 ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-6">
                <img
                  loading="lazy"
                  alt="lazy"
                  src={Group1}
                  className="w-full"
                />
                <img
                  loading="lazy"
                  alt="lazy"
                  src={Group3}
                  className="w-full mt-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center rounded mt-36 max-md:mt-10">
        <div>
          <div className="text-4xl font-semibold leading-10 tracking-tighter text-gray-900 max-md:mt-4 max-md:max-w-full">
            Sign Up
          </div>
          <div className="mt-3 text-slate-600 max-md:max-w-full">
            Register to Access Exclusive Features
          </div>
        </div>

        <div className="flex flex-col justify-start px-1 m-1 w-[412px] ">
          
        {/* Google */}
          <div
            onClick={reachGoogle}
            className="w-full flex gap-3 justify-center py-2.5 hover:cursor-pointer px-6 mt-8 font-semibold bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-slate-700 max-md:flex-wrap max-md:px-5"
          >
            <img
              loading="lazy"
              src={google}
              className="w-6 shrink-0 aspect-square"
              alt="Google"
            />
            <div>Sign up with Google</div>
          </div>

          {/* New */}
          <form className="w-full">
            <div className="flex flex-col gap-y-4">
              {/* Name */}
              <div>
                <label
                  htmlFor="username"
                  className="mb-2 text-base font-medium "
                >
                  Name
                </label>
                <input
                  type="text"
                  id="username"
                  required
                  className={`w-full px-3 py-1 text-sm border rounded-md outline-none ${
                    !errMsg?.username ? "" : "border-red-500"
                  }`}
                  name="name"
                  placeholder="Enter your name"
                  value={signUp.username}
                  onChange={(e) =>
                    setSignUp((pre) => ({
                      ...pre,
                      username: e.target.value,
                    }))
                  }
                />
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.username && (
                    <span className="">{errMsg?.username}</span>
                  )}
                </p>
              </div>

              {/* Email */}
              <div>
                <label for="email" className="mb-2 text-base font-medium ">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  className={`w-full px-3 py-1 text-sm border rounded-md outline-none ${
                    !errMsg?.email ? "" : "border-red-500"
                  }`}
                  name="email"
                  placeholder="name@example.com"
                  value={signUp.email}
                  onChange={handleEmailChange}
                />
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.email && <span className="">{errMsg?.email}</span>}
                </p>
              </div>

              {/* Password */}
              <div>
                <label htmlFor="password" className="mb-2 font-medium">
                  Password
                </label>
                <div className="flex flex-wrap w-full px-3 py-1 border rounded-md">
                  <input
                    type={visible ? "text" : "password"}
                    id="password"
                    required
                    className={`flex-grow text-sm outline-none ${
                      !errMsg?.password ? "" : "border-red-500"
                    }`}
                    name="password"
                    placeholder="password ..."
                    value={signUp.password}
                    onChange={handlePasswordChange}
                  />
                  <div
                    onClick={() => setVisible(!visible)}
                    className="float-left cursor-pointer"
                  >
                    {visible ? (
                      <img src={view} alt="Hide" className="w-4 h-4" />
                    ) : (
                      <img src={hide} alt="View" className="w-4 h-4" />
                    )}
                  </div>
                </div>
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.password && (
                    <span className="">{errMsg?.password}</span>
                  )}
                </p>
              </div>

              {/* confirm-passowre */}
              <div>
                <label htmlFor="confirmPassword" className="mb-2 font-medium">
                  Confirm Password
                </label>
                <div className="flex flex-wrap w-full px-3 py-1 border rounded-md">
                  <input
                    type={visible1 ? "text" : "password"}
                    id="confirmPassword"
                    required
                    className={`flex-grow text-sm outline-none ${
                      !errMsg?.confirmPassword ? "" : "border-red-500"
                    }`}
                    name="confirmPassword"
                    placeholder="Confirm password ..."
                    value={signUp.confirmPassword}
                    onChange={handleConfirmPasswordChange}
                  />
                  <div
                    onClick={() => setVisible1(!visible1)}
                    className="float-left cursor-pointer"
                  >
                    {visible1 ? (
                      <img src={view} alt="Hide" className="w-4 h-4" />
                    ) : (
                      <img src={hide} alt="View" className="w-4 h-4" />
                    )}
                  </div>
                </div>
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.confirmPassword && (
                    <span className="">{errMsg?.confirmPassword}</span>
                  )}
                </p>
              </div>
            </div>

            {/* <br /> */}
            <br />
            <div className="flex gap-x-7">
              <div className="flex">
                <input
                  type="checkbox"
                  name="checkbox"
                  htmlFor="checkbox"
                  id="CheckBox"
                  className="mr-2 hover:cursor-pointer"
                  checked={signUp.teamsAndCondition}
                  onChange={(e) =>
                    setSignUp((prev) => ({
                      ...prev,
                      teamsAndCondition: e.target.checked,
                    }))
                  }
                />
                <span
                  id="checkbox"
                  className="hover:cursor-pointer"
                  onClick={(e) =>
                    setSignUp((prev) => ({
                      ...prev,
                      termsAndConditions: !signUp.termsAndConditions,
                    }))
                  }
                >
                  By signing up, you agree to our{" "}
                  <span
                    className="text-violet-700"
                    // onClick={() => setShow_tac((e) => !e)}
                  >
                    Terms and Conditions
                  </span>
                </span>
              </div>
              {/* 
              <div>
                <button className="text-purple-500 float-end">
                  <Link to={"../reset/password/"}>Forgot password</Link>
                </button>
              </div> */}
            </div>

            <div className="flex w-full">
              <CustomButton
                disabled={disableSignUp()}
                onClick={handleSignUp}
                loading={loading}
                className="py-1 mt-4"
              >
                Register
              </CustomButton>
            </div>
          </form>
          <p className="text-base">
            Already have an account ?{" "}
            <Link className="font-semibold text-violet-700" to={"/login"}>
              Login
            </Link>
          </p>

        </div>
      </div>
      {show_tac && (
        <div className={`tandc_overlay flex ${show_tac ? "block" : "hidden"}`}>
          <div className="tac_content">
            <button className="close_button" 
            onClick={() => setShow_tac(false)}
            >
              &times;
            </button>
            <div className="terms-and-conditions" ref={termsAndConditionsRef}>
              <h2>Terms and Conditions</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                porttitor libero vitae erat lacinia sagittis. Vestibulum vitae
                ligula sollicitudin, pellentesque metus a, rutrum tortor. In id
                enim tristique, dignissim metus non, ullamcorper neque. Mauris
                dictum aliquam velit id luctus. Nulla eu ligula a est tempus
                laoreet. Vivamus nec tristique purus. Pellentesque quam nulla,
                varius non consectetur nec, ultrices at est. Nullam sagittis
                blandit tortor eu pellentesque. Donec interdum eleifend tempus.
                Proin nulla lectus, lacinia nec auctor ut, sagittis in libero.
                Nunc malesuada, nunc at cursus feugiat, diam elit mattis lacus,
                vitae scelerisque mi massa quis justo. In facilisis quam a
                lectus fermentum, auctor tristique nisi facilisis. Suspendisse
                potenti. Donec at accumsan orci, vitae consectetur dolor. Aenean
                vitae nisl id lorem aliquet tristique ac quis nunc.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default connect(null, { signup })(Signup);
